import { TableViewDialog } from "../style";
import Select from "react-select";
import { Input, Label } from "reactstrap";
import { OptionImage } from "../../product/style";
import { useEffect, useState } from "react";

const FillersDialog = ({
  group,
  tableManager,
  updateSectionFillers,
  mutateCurrentRoom,
  access,
}) => {
  const [enabledOverrides, setEnabledOverrides] = useState({
    left: {
      shutter_color: false,
      height: false,
      width: false,
      depth: false,
      thickness: false,
    },
    right: {
      shutter_color: false,
      height: false,
      width: false,
      depth: false,
      thickness: false,
    },
    top: {
      shutter_color: false,
      height: false,
      width: false,
      depth: false,
      extension: false,
      thickness: false,
    },
    bottom: {
      shutter_color: false,
      height: false,
      width: false,
      depth: false,
      extension: false,
      thickness: false,
    },
  });

  useEffect(() => {
    const newOverrides = { ...enabledOverrides };

    Object.entries(group.sides).forEach(([direction, value]) => {
      const keys = Object.keys(value.overrides);

      keys.forEach((key) => {
        newOverrides[direction][key] = true;
      });
    });

    setEnabledOverrides(newOverrides);
  }, []);

  const getSideOptions = (group, direction) => {
    return group.side_options[direction].map((option) => {
      option.value = option.type;
      option.label = option.name;

      return {
        ...option,
      };
    });
  };

  const anyOverridesPresent = (direction) => {
    return Object.keys(enabledOverrides[direction])
      .map((key) => {
        return enabledOverrides[direction][key];
      })
      .some((item) => item);
  };

  const updateEnabledOverrides = (direction, key, value) => {
    setEnabledOverrides({
      ...enabledOverrides,
      [direction]: {
        ...enabledOverrides[direction],
        [key]: value,
      },
    });
  };

  return (
    <TableViewDialog
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={{ padding: "0px", minWidth: "250px" }}
    >
      {Object.keys(group.side_options).map((direction, index) => {
        if (direction === "back") return;

        return (
          <div key={index} className={"capital-letter direction-filler"}>
            <div className={"p-3"}>
              <div className={"capital-letter direction-item"}>
                {direction} Side:
              </div>
              <div className="d-flex align-items-center column-gap-2">
                {access.customize_filler ? (
                  <Select
                    value={getSideOptions(group, direction).find(
                      (option) =>
                        option.value === group.sides[direction]["type"]
                    )}
                    onChange={(e) => {
                      group.sides[direction].type = e.value;
                      mutateCurrentRoom();
                      updateSectionFillers({
                        id: group.id,
                        sides: group.sides,
                      });
                    }}
                    className="w-100"
                    options={getSideOptions(group, direction)}
                    disabled={!access.customize_filler}
                  />
                ) : (
                  <div className="mt-1 text-disabled">
                    {group.sides[direction].type || "No Value"}
                  </div>
                )}
                <div className="d-flex align-items-center column-gap-2">
                  {getSideOptions(group, direction)
                    .find(
                      (option) =>
                        option.value === group.sides[direction]["type"]
                    )
                    .possible_overrides.map((override, index) => {
                      return (
                        <div className="d-flex column-gap-2">
                          <Input
                            id={`${direction}_${override.key}`}
                            type="checkbox"
                            key={`${index}_${direction}`}
                            checked={enabledOverrides[direction][override.key]}
                            className="m-0"
                            onChange={(e) => {
                              updateEnabledOverrides(
                                direction,
                                override.key,
                                e.target.checked
                              );

                              if (!e.target.checked) {
                                delete group.sides[direction]["overrides"][
                                  override.key
                                ];
                                updateSectionFillers({
                                  id: group.id,
                                  sides: group.sides,
                                });
                              }
                            }}
                            disabled={!access.customize_filler}
                          ></Input>
                          <Label
                            className="text-secondary m-0 text-nowrap"
                            for={`${direction}_${override.key}`}
                          >
                            {override.name}
                          </Label>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            {anyOverridesPresent(direction) && (
              <div className="d-flex column-gap-3 bg-body-dark p-3">
                {Object.keys(enabledOverrides[direction]).map((overrideKey) => {
                  if (enabledOverrides[direction][overrideKey]) {
                    if (overrideKey === "shutter_color") {
                      return (
                        <div>
                          <p className="mb-1">Color</p>
                          <div>
                            {(() => {
                              const property = group.property_list.find(
                                (e) => e.identifier === "shutter_color"
                              );

                              return (
                                <>
                                  {access.customize_filler ? (
                                    <>
                                      <Select
                                        className="list-summary-select"
                                        key={index}
                                        value={
                                          property.options.find(
                                            (o) =>
                                              o.identifier ===
                                              group.sides[direction].overrides
                                                .shutter_color
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          group.sides[
                                            direction
                                          ].overrides.shutter_color =
                                            selectedOption.identifier;
                                          mutateCurrentRoom();
                                          updateSectionFillers({
                                            id: group.id,
                                            sides: group.sides,
                                          });
                                        }}
                                        options={property.options.map(
                                          (option, optionIndex) => {
                                            option.value = option.name;
                                            option.label = (
                                              <div key={optionIndex}>
                                                {option.image && (
                                                  <OptionImage
                                                    src={option.image}
                                                    alt={option.name}
                                                    className="border border-dark rounded-circle me-2"
                                                  />
                                                )}
                                                {option.name}
                                              </div>
                                            );

                                            option.key = index;

                                            return {
                                              value: option.name,
                                              label: option.name,
                                              ...option,
                                            };
                                          }
                                        )}
                                      />
                                      {!group.sides[direction].overrides
                                        .shutter_color && (
                                        <p className="m-0 grey_letter mt-2">{`Using ${property.value_name}`}</p>
                                      )}
                                    </>
                                  ) : (
                                    group.sides[direction].overrides
                                      .shutter_color && (
                                      <div className="mt-1 text-disabled">
                                        {group.sides[direction].type ||
                                          "No Value"}
                                      </div>
                                    )
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      );
                    }

                    if (
                      ["extension", "height", "width", "depth"].includes(
                        overrideKey
                      )
                    )
                      return ["extension", "height", "width", "depth"].map(
                        (e) => {
                          if (overrideKey === e)
                            return (
                              <div>
                                <p className="mb-1">{e}</p>
                                <Input
                                  className="w-50px"
                                  type="number"
                                  defaultValue={
                                    group.sides[direction].overrides[e] || ""
                                  }
                                  onBlur={(event) => {
                                    if (event.target.value.length > 0) {
                                      group.sides[direction].overrides[e] =
                                        parseInt(event.target.value);
                                      mutateCurrentRoom();
                                      updateSectionFillers({
                                        id: group.id,
                                        sides: group.sides,
                                      });
                                    }
                                  }}
                                  disabled={!access.customize_filler}
                                ></Input>
                              </div>
                            );
                        }
                      );

                    if (overrideKey === "thickness") {
                      return (
                        <div>
                          <p className="mb-1">Thickness</p>
                          <div>
                            {(() => {
                              const options =
                                group.end_panel_thickness_options[direction];

                              return (
                                <>
                                  {access.customize_filler ? (
                                    <>
                                      <Select
                                        className="list-summary-select"
                                        key={index}
                                        value={
                                          options.find(
                                            (o) =>
                                              o.sku ==
                                              group.sides[direction].overrides
                                                .thickness
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          group.sides[
                                            direction
                                          ].overrides.thickness =
                                            selectedOption.value;
                                          mutateCurrentRoom();
                                          updateSectionFillers({
                                            id: group.id,
                                            sides: group.sides,
                                          });
                                        }}
                                        options={options.map((option) => {
                                          option.value = option.sku;
                                          option.label = option.name;

                                          return {
                                            ...option,
                                          };
                                        })}
                                        disabled={!access.customize_filler}
                                      />
                                    </>
                                  ) : (
                                    group.sides[direction].overrides
                                      .thickness && (
                                      <div className="mt-1 text-disabled">
                                        {group.sides[direction].type ||
                                          "No Value"}
                                      </div>
                                    )
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      );
                    }
                  }
                })}
              </div>
            )}
          </div>
        );
      })}
      <div
        className={"done-button m-3"}
        onClick={(e) => {
          e.stopPropagation();
          tableManager.set(null, null, null, null);
        }}
      >
        Done
      </div>
    </TableViewDialog>
  );
};

export default FillersDialog;
